import React, { useState } from 'react';
import TextEvents from '../TextEvents';
import { Grid } from '@material-ui/core';
import { Button, Select, DatePicker, Checkbox, Icon, Row, Col, Tooltip } from 'antd';
import IconButton from '@material-ui/core/IconButton';

import {
    fetchCourse,
    courseClear,
    courseCategoryAvailableClear,
    courseCategoryClear,
    courseTestAvailableClear,
    courseTestClear,
    courseWorkCycleAvailableClear,
    courseWorkCycleClear,
    courseClientProcedureAvailableClear,
    courseClientProcedureClear,
    courseHomologousProcedureAvailableClear,
    courseHomologousProcedureClear
} from 'app/actions/CourseActions';
import { attachmentClear } from "app/actions/AttachmentActions";
import { clearCourseMultimedia } from 'app/actions/CourseMultimediaActions';
import { styles, useStyles } from './ProcedureFormStyle';
import ApiService from 'app/services/ApiService';
import CourseTableContainer from 'app/containers/CourseTableContainer';
import { connect, useDispatch, useSelector } from 'react-redux';
const { Option } = Select;
const SelectItem = (name = [], value) => {
    let x = name[value]
    return typeof x !== 'undefined' && x !== null ? x.map((c, i) => <Option key={i}>{c}</Option>) : (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

const SelectItemObject = (name = [], value) => {
    let x = name[value]

    if (x !== undefined && x.length > 0) {
        return x.map(z => <Option key={z.idFile} value={z.idFile}>{z.fileUser}</Option>)
    }
    return (x === null ? <Option key={'cargando'}>No existen valores..</Option> : <Option disabled key={'cargando'}>Cargando valores..</Option>);

}

function ProcedureForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const {
        Permissions
        , Roles
    } = useSelector(state => state.Auth.item.User);

    let [subdirList, setSubdirList] = useState();

    const [id, setId] = useState([]);
    const [subdirec, setSubdirect] = useState([]);
    const [version, setVersion] = useState([]);
    const [code, setCode] = useState([]);
    const [name, setName] = useState([]);
    const [status, setStatus] = useState([]);
    const [testFolio, setTestFolio] = useState([]);
    const [testCTFolio, setTestCTFolio] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [creationDateI, setCreationDateI] = useState('');
    const [creationDateF, setCreationDateF] = useState('');
    const [modificationDateI, setModificationDateI] = useState('');
    const [modificationDateF, setModificationDateF] = useState('');
    const [training, setTraining] = useState([]);
    const [systemSpecialty, setSystemSpecialty] = useState([]);
    const [category, setCategory] = useState([]);
    const [notSuspended, setNotSuspended] = useState(false);
    const [collapse, setCollapse] = useState(true);
    // const [folioPDC, setFolioPDC] = useState([]);
    // const [filesUsers, setFichaUsuario] = useState([]);

    const {
        idSubdirection,
        employeeId
    } = useSelector(state => state.Auth.employeeById)

    const {
        siteId
    } = useSelector(state => state.Auth)

    const SelectSubdirItem = (name = [], value) => {
        setSubdirList(name);
        let x = [...new Set(name.map(i => i[value]))];
        x = name.map(i => i[value]);
        return (
            x.map((c, i) => <Option key={i}>{c}</Option>)
        );
    }

    const downloadVideos = () => {
    }

    
    const validateAdminGeneralRol = () => {
        let findRol = Roles.find(rol => rol.NameRole.includes("Administrador General"))
        return findRol ? true : false;
    }

    const permisosArray = () => {
        let permissions = Permissions.filter(x => x.NameController === 'CourseScreen' && x.Description.includes("Modulo de")).map(item => {
            return item.NameResource;
        })
        let response = [];
        permissions.forEach(row => {
            switch (row) {
                case "ModuleCourseDocument":
                    response.push("ModuleCourseDocument");
                    break;
                case 'ModuleCourseCategory':
                    response.push("ModuleCourseCategory");
                    break;
                case "ModuleCourseMultimedia":
                    response.push("ModuleCourseMultimedia");
                    break;
                case "ModuleCourseEvaluation":
                    response.push("ModuleCourseEvaluation");
                    break;
                case "ModuleCourseDutyCycle":
                    response.push("ModuleCourseDutyCycle");
                    break;
                case "ModuleCourseClientProcedure":
                    response.push("ModuleCourseClientProcedure");
                    break;
            }

        })
        return response
    }

    const data = {
        employeeId: employeeId,
        subdirectionId: idSubdirection,
        CourseFolio: id.toString(),
        CourseName: name.join('|'),
        TestFolio: testFolio,
        TestCTFolio: testCTFolio,
        Status: status,
        Subdirection: subdirec,
        CourseVersion: version,
        CourseCode: code,
        CourseDateCreationInitial: creationDateI,
        CourseDateCreationFinal: creationDateF,
        CourseDateModificationInitial: modificationDateI,
        CourseDateModificationFinal: modificationDateF,
        Trainings: training.length > 0 ? training[0].join("|") : '',
        SystemSpecialty: systemSpecialty.length > 0 ? systemSpecialty[0].join("|") : '',
        Categories: category.length > 0 ? category[0].join("|") : '',
        NotSuspended: notSuspended,
        sortColumn: Object.keys(props.sorter).length > 0 ? props.sorter.field : '',
        sortDir: Object.keys(props.sorter).length > 0 ? props.sorter.order === "ascend" ? "ASC" : "DESC" : '',
        offset: (0 * props.pagination.pageSize),
        limit: props.pagination.pageSize,
        IsAdminGeneral: validateAdminGeneralRol(),
        PermisosPantalla: validateAdminGeneralRol() ? permisosArray() : []
        // FolioPDC: folioPDC,
        // FichaUsuario: filesUsers
    }
    const search = () => {
        // if (data.FichaUsuario.length == 0) data.FichaUsuario = ['N/A'];
        dispatch(courseClear())
        dispatch(fetchCourse(data));
        props.setFormData(data);
    }

    const newCourse = () => {
        dispatch(courseCategoryAvailableClear());
        dispatch(courseCategoryClear());
        dispatch(courseTestAvailableClear());
        dispatch(courseTestClear());
        dispatch(courseWorkCycleClear());
        dispatch(courseWorkCycleAvailableClear());
        dispatch(attachmentClear());
        dispatch(clearCourseMultimedia());
        dispatch(courseClientProcedureAvailableClear());
        dispatch(courseClientProcedureClear());
        dispatch(courseHomologousProcedureAvailableClear());
        dispatch(courseHomologousProcedureClear());
        props.setTab('2');
    }
    const toExport = async () => {
        await ApiService.getCoursesExport(data)
            .then(
                result => {
                    const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    downloadFile(blob, "Procedimientos.xlsx");
                },
                error => {
                    // eslint-disable-next-line no-throw-literal
                    throw ({ error: error, message: 'An error ocurred' });
                }
            )
    }

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
    };

    const handleChange = (value, i, key) => {
        const array = [];
        i.map(i => {
            array.push(i.props.children);
            return array;
        })
        if (i.length === 0) {
            switch (key) {
                case 'folio':
                    setId([])
                    break;
                case 'testFolio':
                    setTestFolio([])
                    break;
                case 'testCTFolio':
                    setTestCTFolio([])
                    break;
                case 'subdirectionName':
                    setSubdirect([])
                    break;
                case 'statusName':
                    setStatus([])
                    break;
                case 'name':
                    setName([])
                    break;
                case 'version':
                    setVersion([])
                    break;
                case 'code':
                    setCode([])
                    break;
                case 'training':
                    setTraining([]);
                    break;
                case 'systemSpecialty':
                    setSystemSpecialty([]);
                    break;
                case 'category':
                    setCategory([]);
                    break;
                case 'notSuspended':
                    setNotSuspended([]);
                    break;
                // case 'folioPDC':
                //     setFolioPDC([]);
                //     break;
                // case 'filesUsers':
                //     setFichaUsuario([])
                //     break;
                default:
                    break;
            }
        }

        const keyToSetter = {
            'folio': setId,
            'testFolio': setTestFolio,
            'testCTFolio': setTestCTFolio,
            'subdirectionName': setSubdirect,
            'statusName': setStatus,
            'name': setName,
            'version': setVersion,
            'code': setCode,
            'training': setTraining,
            'systemSpecialty': setSystemSpecialty,
            'category': setCategory,
            // 'folioPDC': setFolioPDC,
            // 'filesUsers': setFichaUsuario
        };
        //eslint-disable-next-line array-callback-return
        i.map(() => {
            const setter = keyToSetter[key];
            if (setter) {
                if (key === 'subdirectionName') {
                    const newsubdirList = array.map((z) => {
                        const res = subdirList.find((ids) => ids.subdirectionName === z);
                        return res ? res.idSubdirection : null;
                    });
                    setter([newsubdirList]);
                    // } else if (key === 'filesUsers') {
                    //     setter([value]);
                    // 
                } else {
                    setter([array]);
                }
            }
        });
    }
    return (
        <div>
            <CourseTableContainer>
                {(params) => {
                    return (
                        <div>
                            <div hidden={collapse}>
                                {/* <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Ficha/Usuario:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona ficha o usuario"
                                            onChange={(v, i) => handleChange(v, i, 'filesUsers')}
                                        >
                                            {SelectItemObject(params.courseFilter[0], 'filesUsers')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio de PDC:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio"
                                            onChange={(v, i) => handleChange(v, i, 'folioPDC')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'folioPDC')}
                                        </Select>
                                    </Grid>
                                </Grid> */}
                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio"
                                            onChange={(v, i) => handleChange(v, i, 'folio')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'folio')}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={6}>

                                        <TextEvents
                                            text='Nombre:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona nombre "
                                            onChange={(v, i) => handleChange(v, i, 'name')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'name')}
                                        </Select>
                                    </Grid>

                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Tipo de Capacitación:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona Tipo de Capacitación"
                                            onChange={(v, i) => handleChange(v, i, 'training')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'trainings')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Especialidad / Sistema:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona Especialidad / Sistema"
                                            onChange={(v, i) => handleChange(v, i, 'systemSpecialty')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'systemSpecialty')}
                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio de Evaluación:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio de evaluación"
                                            onChange={(v, i) => handleChange(v, i, 'testFolio')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'testFolio')}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Subdirección destino:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode='multiple'
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder='Selecciona subdirección'
                                            onChange={(v, i) => handleChange(v, i, 'subdirectionName')}
                                        >
                                            {params.courseFilter[0] !== undefined ? SelectSubdirItem(params.courseFilter[0].subdirection, 'subdirectionName') : null}
                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Folio de Ciclo de Trabajo:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona folio de Ciclo de Trabajo "
                                            onChange={(v, i) => handleChange(v, i, 'testCTFolio')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'testCTFolio')}
                                        </Select>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Estatus'
                                            color='darker'
                                            size='label'
                                            weight='medium'
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona estatus"
                                            onChange={(v, i) => handleChange(v, i, 'statusName')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'statusName')}

                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Puesto:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Subdirección puesto "
                                            onChange={(v, i) => handleChange(v, i, 'category')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'category')}

                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Versión:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                            placeholder="Selecciona versión "
                                            onChange={(v, i) => handleChange(v, i, 'version')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'version')}

                                        </Select>
                                    </Grid>
                                </Grid>

                                <Grid container direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Código:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Select
                                            mode="multiple"
                                            showSearch
                                            optionFilterProp="children"
                                            style={styles.inputSelect}
                                            placeholder="Selecciona código"
                                            onChange={(v, i) => handleChange(v, i, 'code')}
                                        >
                                            {SelectItem(params.courseFilter[0], 'code')}
                                        </Select>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Fecha de Creación:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setCreationDateI(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setCreationDateF(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}

                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={1} direction="row">
                                    <Grid item xs={6}>
                                        <TextEvents
                                            text='Fecha de Modificación:'
                                            color="darker"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Grid container spacing={2} direction="row">
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setModificationDateI(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <DatePicker
                                                    style={{ ...styles.fullWidth, ...styles.smallBottomMargin }}
                                                    format={'DD/MM/YYYY'}
                                                    onChange={(date, dateString) => {
                                                        setModificationDateF(dateString !== "" ? dateString.split('/').reverse().join('/') : '');
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6} >
                                        <TextEvents
                                            text='.'
                                            color="white"
                                            size='label'
                                            weight="medium"
                                        />
                                        <Checkbox onChange={(e) => setNotSuspended(e.target.checked)}>No considerar Suspendidos / Baja</Checkbox>
                                    </Grid>
                                </Grid>

                            </div>

                            <div className={classes.container} style={styles.baseVerticalMargin}>
                                {
                                    collapse ?
                                        <Tooltip title={"Mostrar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(false)}
                                            >
                                                <Icon type="down" />
                                            </Button>
                                        </Tooltip> :
                                        <Tooltip title={"Ocultar filtro"}>
                                            <Button
                                                className={classes.button}
                                                variant="contained"
                                                type="link"
                                                onClick={() => setCollapse(true)}
                                            >
                                                <Icon type="up" />
                                            </Button>
                                        </Tooltip>
                                }
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={() => search()}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="primary"
                                    onClick={toExport}
                                >
                                    Exportar
                                </Button>
                                {
                                    siteId === 'HUB' ?
                                        <Button
                                            className={classes.button}
                                            variant="contained"
                                            type="primary"
                                            onClick={newCourse}
                                        >
                                            Nuevo
                                        </Button> : null
                                }
{/* 
                                <Button
                                    className={classes.button}
                                    variant="contained"
                                    type="success"
                                    onClick={downloadVideos}
                                    disabled={props.selectedRows.length == 0}
                                >
                                    Descargar Videos
                                </Button> */}
                            </div>
                        </div>);
                }}
            </CourseTableContainer>
        </div>
    );
}
export default connect()(ProcedureForm);